import { Input, InputRef } from 'antd';
import { RiSearch2Line } from 'react-icons/ri';
import { forwardRef } from 'react';

interface SearchContactInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  suffix?: React.ReactNode;
  autoFocus?: boolean;
  onPressEnter?: () => void;
}

export const SearchContactInput = forwardRef<InputRef, SearchContactInputProps>(
  (
    { value, onChange, placeholder = 'Search by name or phone number', error, suffix, autoFocus = true, onPressEnter },
    ref
  ) => (
    <Input
      ref={ref}
      size="large"
      placeholder={placeholder}
      prefix={<RiSearch2Line size={18} className="text-gray-700" />}
      suffix={suffix}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onPressEnter={onPressEnter}
      status={error ? 'error' : ''}
      className="mb-2"
      autoFocus={autoFocus}
    />
  )
);

SearchContactInput.displayName = 'SearchContactInput';
